module.exports = __webpack_public_path__ + "static/media/12.7ebb78c1.jpg";